<template>
  <Dialog header="This customer already has a quotation on this enquiry" :visible="visible" :modal="true" :closable="false" :style="{ width: '620px' }"
    class="pse-question">
    <div :class="['pse-note', blocked ? 'error' : 'warn']">
      <i :class="blocked ? 'pi pi-ban' : 'pi pi-exclamation-triangle'"></i>
      <span>
        <span v-for="e in quotes" :key="e.oppId" class="pse-question-line">{{ sentence(e) }}</span>
        <strong v-if="blocked">Same branch: make a new version of that quotation instead.</strong>
      </span>
    </div>
    <template #footer>
      <div class="pse-question-buttons">
        <Button v-for="e in quotes" :key="'v' + e.oppId" :label="versionLabel(e)" :icon="e.canCreateVersion ? 'pi pi-copy' : 'pi pi-external-link'"
          class="p-button-success pse-question-version" @click="$emit('newVersion', e)" />
        <Button v-if="!blocked" label="New Quotation anyway" icon="pi pi-plus" class="p-button-warning pse-question-anyway" @click="$emit('anyway')" />
        <Button label="Change customer" icon="pi pi-user-edit" class="p-button-outlined pse-question-change" @click="$emit('change')" />
      </div>
    </template>
  </Dialog>
</template>

<script>
import { existingQuotes, existingSentence } from './customerQuotes'

// Designs B and D (Mohammed 18/10): the duplicate question asked up front, over the form, as soon as the customer, the
// product type and the branch are chosen. BLOCK (same branch) has no "anyway".
export default {
  name: 'DuplicateQuestion',
  props: {
    visible: { type: Boolean, default: false },
    // the checkCustomer result
    check: { type: Object, default: null },
    custName: { type: String, default: '' }
  },
  computed: {
    blocked() { return !!this.check && this.check.result === 'BLOCK' },
    quotes() { return existingQuotes(this.check) }
  },
  methods: {
    sentence(e) { return existingSentence(this.custName, e) },
    versionLabel(e) {
      if (e.canCreateVersion) return 'Create New Version of ' + e.sQuoteNo
      return 'Open enquiry' + (e.sQuoteNo ? ' ' + e.sQuoteNo : '')
    }
  }
}
</script>

<style scoped>
@import './sharedEnquiry.css';
.pse-question-line { display: block; margin-bottom: 4px; }
.pse-question-buttons { display: flex; flex-wrap: wrap; gap: 8px; justify-content: flex-end; }
.pse-question-buttons .p-button { width: auto; }
</style>
